import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";

import "./ClienteSucesso.scss";
import Logo from "../../../../assets/images/02_washpass.png";
import Footer from "../../../Footer";

const ClienteLPSuccess = () => {
  return (
    <>
      <div className="LpClienteSucesso">
        <Box className="MainSection">
          <Container maxWidth="lg">
            <Grid container justifyContent={"space-evenly"}>
              <Grid item className="Presentation" xs={12}>
                <img src={Logo} className="Logo" />
                <Typography variant="h2" component="h2" className="MainText">
                  Cadastro efetuado com sucesso!
                </Typography>
                <Typography
                  variant="h3"
                  component="p"
                  className="SecondaryText"
                >
                  Em breve você receberá maiores novidades sobre o maior clube
                  automotivo do Brasil.
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </Box>
        <Footer />
      </div>
    </>
  );
};

export default ClienteLPSuccess;
